module.exports = __webpack_public_path__ + "img/despacho.b13efd2f.png";